// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import iView from 'view-design';
import 'view-design/dist/styles/iview.css';
// import iView from 'iview'
// import 'iview/dist/styles/iview.css'
import App from './App'
import axios from 'axios'
import './js/script/fvGlobal.js';
import './debug.js';
import "./js/div/animationDiv";
import "./js/canvas/animation";
import "./js/render";
import "./components/_globals";
import VueDragResize from 'vue-drag-resize';
import { fabric } from 'fabric';
Vue.use(fabric);
Vue.component('vue-drag-resize', VueDragResize);
//不可删除，防止拼接路由地址时出现undeiend开头的路由地址。调试启动文件此字段有相应赋值
window.debugFWebView = "";
// 导出Excel
import Blob from './assets/exportExcel/Blob'
import Export2Excel from './assets/exportExcel/Export2Excel'
Vue.use(iView);
Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
  },
  modules : {
  }
})

Vue.config.productionTip = false;

new Vue({
  el: '#app',
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js